export default "__VITE_ASSET__2LWbSWAvfunqN68WgbME5g__"